import React, { useState } from 'react'
import { Button, Grid, Typography, Card, CardContent, CardActions, CardMedia, Box } from '@mui/material'
import _ from "lodash"
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { useDispatch, useSelector } from 'react-redux';
import { selectArticleById } from '../../../reducers/healthshelf_article';
import { useNavigate } from 'react-router';
import { createSearchParams } from 'react-router-dom';
import { healthshelfClear } from '../../../reducers/healthshelf_single';


const ArticleItem = (props) => {
    const ArticleId = props.ArticleId
    const Article = useSelector((state) => selectArticleById(state, ArticleId))
    const [isOpen, setIsOpen] = useState()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    //     setIsFlipped(-1)
    //     setCurrentTab(props.cards.KeyAreas.KeyAreaArray[newValue])
    // };

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }

    const LoadArticle = ()=>{
        dispatch(healthshelfClear())
        navigate({ pathname: '/healthshelfarticle', search: createSearchParams({ hsg: Article.Guid}).toString() })
    }

    return (

        <Card sx={{ display: "flex", height:"100%", flexDirection: "column" }}>
            <CardMedia
                component="img"
                height="194"
                image={"../"+Article.Image+"/"}

            />
            <CardContent>
                <Grid container direction="row" alignItems="top">
                    <Grid item xs={12}>
                        <Typography variant="h6" align="center" gutterBottom>{Article.ComponentValues.TitleBlock.Title}</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography ml={1} variant="body2" sx={{ p: 2 }} dangerouslySetInnerHTML={{ __html: _.unescape(Article.ComponentValues.Abstract) }}></Typography>
                    </Grid>
                </Grid>
            </CardContent>
            <Box sx={{flexGrow:1}}/>
            <CardActions p={2}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={6} alignItems="left">
                        <Button onClick={() => LoadArticle()}>Read More</Button>
                    </Grid>
                    <Grid item xs={6} alignItems="right">
                        <Typography ml={1} variant="body2" align="center" sx={{ mb: 1.5 }}><AccessTimeIcon /> {Article.ComponentValues.TitleBlock.ReadingTime}</Typography>
                    </Grid>
                </Grid>
            </CardActions>
            
        </Card>

    )

}


export default ArticleItem;